import { Typography } from '@mui/material'
import parseHtml from 'html-react-parser'
import QrCode2Icon from '@mui/icons-material/QrCode2'

import StyledPaper from '/components/paper'

const Templates = ({ templates, tabIndex, selectedTemplate, setSelectedTemplate }) => {

  if (tabIndex === "standard") return StandardTemplates({ templates, selectedTemplate, setSelectedTemplate })
  if (tabIndex === "managed") return ManagedTemplates({ templates, selectedTemplate, setSelectedTemplate })
  if (tabIndex === "specialist") return SpecialistTemplates({ templates, selectedTemplate, setSelectedTemplate })
  if (tabIndex === "examples") return ExampleTemplates({ templates, selectedTemplate, setSelectedTemplate })
}

export default Templates

const StandardTemplates = ({ templates, selectedTemplate, setSelectedTemplate }) => {

  const tps = templates.filter(t => t.smartix_scanner === 0 && t.specialist_template === 0 && !/Example/.test(t.name)).map(t => {

    const classes = selectedTemplate === t.id ? "selectable selected " : "selectable "

    return (
      <div key={t.id} onClick={() => setSelectedTemplate(t)} className='pointer'>
        <StyledPaper classes={classes}>
          <div className='flex-col justify-around' style={{ height: 650, width: 300 }}>
            <div className='h-[60px]'><Typography variant='h6'>{t.name}</Typography></div>
            <img src={`https://s3.eu-west-1.amazonaws.com/images.smartix.uk/previews/${t.pass_type_id}-apple.png`} width="100%" className='mt-5 mb-5' />
            <p>{parseHtml(t.description)}</p>
          </div>
        </StyledPaper>
      </div>
    )
  })

  return tps
}

const ManagedTemplates = ({ templates, selectedTemplate, setSelectedTemplate }) => {

  const tps = templates.filter(t => t.smartix_scanner === 1 && !/Example/.test(t.name)).map(t => {

    const classes = selectedTemplate === t.id ? "selectable selected " : "selectable "

    return (
      <div key={t.id} onClick={() => setSelectedTemplate(t)} className='pointer'>
        <StyledPaper classes={classes}>
          <div className='flex-col justify-around' style={{ height: 650, width: 300 }}>
            <div className='h-[60px]'><Typography variant='h6'><QrCode2Icon/> {t.name}</Typography></div>
            <img src={`https://s3.eu-west-1.amazonaws.com/images.smartix.uk/previews/${t.pass_type_id}-apple.png`} width="100%" className='mt-5 mb-5' />
            <p>{parseHtml(t.description)}</p>
          </div>
        </StyledPaper>
      </div>
    )
  })

  return tps
}

const SpecialistTemplates = ({ templates, selectedTemplate, setSelectedTemplate }) => {

  const tps = templates.filter(t => t.specialist_template === 1 && !/Example/.test(t.name)).map(t => {

    const classes = selectedTemplate === t.id ? "selectable selected " : "selectable "

    return (
      <div key={t.id} onClick={() => setSelectedTemplate(t)} className='pointer'>
        <StyledPaper classes={classes}>
          <div className='flex-col justify-around' style={{ height: 650, width: 300 }}>
            <div className='h-[60px]'><Typography variant='h6'>{t.name}</Typography></div>
            <img src={`https://s3.eu-west-1.amazonaws.com/images.smartix.uk/previews/${t.pass_type_id}-apple.png`} width="100%" className='mt-5 mb-5' />
            <p>{parseHtml(t.description)}</p>
          </div>
        </StyledPaper>
      </div>
    )
  })

  return tps
}


const ExampleTemplates = ({ templates, selectedTemplate, setSelectedTemplate }) => {

  const tps = templates.filter(t => t.specialist_template === 0 && /Example/.test(t.name)).map(t => {

    const classes = selectedTemplate === t.id ? "selectable selected " : "selectable "

    return (
      <div key={t.id} onClick={() => setSelectedTemplate(t)} className='pointer'>
        <StyledPaper classes={classes}>
          <div className='flex-col justify-around' style={{ height: 650, width: 300 }}>
            <div className='h-[60px]'><Typography variant='h6'>{t.smartix_scanner ? <QrCode2Icon/> : ''} {t.name}</Typography></div>
            <img src={`https://s3.eu-west-1.amazonaws.com/images.smartix.uk/previews/${t.pass_type_id}-apple-demo.png`} width="100%" className='mt-5 mb-5' />
            <p>{parseHtml(t.description)}</p>
          </div>
        </StyledPaper>
      </div>
    )
  })

  return tps
}